/* A task in the chat (chat tasks M2, GH #3041): the checkbox before the text, in the body column */
.row {
  display: flex;
  align-items: flex-start;
  gap: var(--tuna-spacing-1);
}

/*
 * 32 px on a fine pointer, 44 px on a coarse one (spec §6, WCAG 2.5.8). Above the text column: an editor block widens
 * its hover area 32 px to the left for its margin handle (core-block.module.css, .block::before), and in this row that
 * strip lay over the checkbox and took its clicks.
 */
.checkbox {
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  min-width: 32px;
  min-height: 32px;
}

@media (pointer: coarse) {
  .checkbox {
    min-width: 44px;
    min-height: 44px;
  }
}

.text {
  flex: 1;
  min-width: 0;
}

/* Done: only the strike marks it, so it stays readable as history */
.struck {
  text-decoration: line-through;
  color: var(--tuna-palette-text-primary);
}

/* T7, in the row's time style */
.done {
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-palette-text-secondary);
}
